import { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { createPCC } from '../../apis/pccApi';

const { TextArea } = Input;

const PCCCreate = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await createPCC(values.comment);
      if (onSuccess) onSuccess();
      message.success('PQR creado exitosamente');
    } catch (error) {
      message.error('Error al creat tu PQR, contacta a soporte');
    } finally {
      setLoading(false);
    }
  };

  return (
      <Form className='my-3' layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Describe tu solicitud"
          name="comment"
          rules={[{ required: true, message: 'La descripción es obligatoria' }]}
        >
          <TextArea
            autoSize={{ minRows: 5, maxRows: 18 }}
            placeholder="Escribe tu petición aquí..."
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Crear
          </Button>
        </Form.Item>
      </Form>
  );
};

export default PCCCreate;
